var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3200_61912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83339 12.1199C5.32566 12.0048 4.83803 11.8142 4.38672 11.5547",
    stroke: "#0C1721",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.16797 1.87891C9.32773 2.14378 10.3632 2.79456 11.1048 3.72469C11.8465 4.65483 12.2504 5.8092 12.2504 6.99882C12.2504 8.18844 11.8465 9.34282 11.1048 10.273C10.3632 11.2031 9.32773 11.8539 8.16797 12.1187",
    stroke: "#0C1721",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.67278 9.96903C2.35458 9.50672 2.1129 8.99619 1.95703 8.45703",
    stroke: "#0C1721",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.82422 6.12505C1.91755 5.57089 2.09722 5.04589 2.34922 4.56464L2.4478 4.38672",
    stroke: "#0C1721",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.02734 2.66991C4.57314 2.29418 5.18545 2.02574 5.83159 1.87891",
    stroke: "#0C1721",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3200_61912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgress);
export default __webpack_public_path__ + "static/media/progress.dcfbcf0b6aa52e516661dcba7641342f.svg";
export { ForwardRef as ReactComponent };